"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deriveStoreWeekStatus = void 0;
const derive_order_status_1 = require("./derive-order-status");
/**
 * `order === null` → NONE (no proposal for the week yet, units 0). Otherwise
 * units = sum of line quantities, and: EDITABLE + no `EDITED` in history →
 * PENDING (the untouched roll-forward, not yet reviewed by the store).
 * Everything else — EDITED, or CLOSED regardless of history — resolves to
 * the final units-based read: ZEROED (opt-out, every line at zero) or SAVED.
 */
const deriveStoreWeekStatus = (order, now) => {
    if (order === null)
        return { status: 'NONE', units: 0 };
    const units = order.products.reduce((sum, line) => sum + line.quantity, 0);
    const hasBeenEdited = (order.history ?? []).some((entry) => entry.event === 'EDITED');
    if ((0, derive_order_status_1.deriveOrderStatus)(order, now) === 'EDITABLE' && !hasBeenEdited) {
        return { status: 'PENDING', units };
    }
    return { status: (0, derive_order_status_1.isOptedOut)(order) ? 'ZEROED' : 'SAVED', units };
};
exports.deriveStoreWeekStatus = deriveStoreWeekStatus;
//# sourceMappingURL=store-week-status.js.map